import { STORAGE_OBJECTS_ENTITY } from '../Entities';
import RepositoryUploader from './RepositoryUploader';

const ACTION_UPLOAD_OBJECT = 'uploadObject';

class RepositoryService {
  constructor(config, store, options = {}) {
    this.apiClient = config.apiClient;
    this.authService = config.authService;
    this.apiClientPrefix = config.apiClientPrefix;
    this.repoUploader = new RepositoryUploader({ shared: true, apiClient: config.apiClient });
    const { uri = '/storage/objects', type = 'StoredObject' } = options;
    this.uri = uri;
    this.store = store;

    // Register the storage objects entity
    store.addEntity(STORAGE_OBJECTS_ENTITY, {
      request: (context) => {
        // Force the shared parameter
        let { query } = context;
        if (!query || !query.length) {
          query = '?shared=true';
        } else if (query.indexOf('shared=') < 0) {
          query = `${query}&shared=true`;
        }
        return this.requestObjects(query)
          .then((res) => {
            const data = res.data.filter(o => o.shared && o.closed);
            return { ...res, data };
          });
      },
      type: config.schemaService.getType(type),
      defaultValue: [],
    });
  }

  requestObjects(query) {
    return this.apiClient.get(`${this.uri}${query || ''}`);
  }

  fetchSharedObjects() {
    return this.requestObjects('?shared=true').then(res => res.data);
  }

  fetchAllObjects() {
    return this.requestAllObjects().then(res => res.data);
  }

  requestAllObjects() {
    return this.requestObjects('?shared=true');
  }

  deleteObjects(objects) {
    return Promise.all(
      objects.map(object => this.requestDeleteObject(object.id)),
    ).then((res) => {
      this.store.update(STORAGE_OBJECTS_ENTITY);
      return res;
    });
  }

  requestDeleteObject(objectId) {
    return this.apiClient.delete(`${this.uri}/${objectId}`);
  }

  // Upload
  validateUpload() {
    return this.authService.canPerformAction(ACTION_UPLOAD_OBJECT);
  }

  getUploader() {
    return this.repoUploader;
  }

  getStoreObjectDownloadURL(objId) {
    return `${this.apiClientPrefix}${this.uri}/${objId}/content`;
  }
}

export default RepositoryService;
